var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractContentProvider = void 0;
var _ = __importStar(require("underscore"));
var Localize_1 = require("../../../gen-src/Localize");
var L10n_1 = require("../../localizationUtils/L10n");
var messages_1 = require("../../messages");
var notificationHelper_1 = require("../../utils/notificationHelper");
var MessagesWithEscapedMarkdown_1 = require("../MessagesWithEscapedMarkdown");
var NotificationDefaultProvider_1 = require("../NotificationDefaultProvider");
var UserNotificationType_1 = require("../UserNotificationType");
var AlertErrorCodes_1 = require("./AlertErrorCodes");
var ExtractContentProvider = (function (_super) {
    __extends(ExtractContentProvider, _super);
    function ExtractContentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtractContentProvider.prototype.getNotificationTitle = function (notification) {
        var content = notification.content;
        var workbookCount = content.workbookCount;
        var workbookName = content.workbookName;
        var datasourceName = content.datasourceName;
        var isDatasourceFailure = !!content.dataConnectionId;
        if (notification.type === UserNotificationType_1.UserNotificationType.CreateExtractFailure) {
            if (isDatasourceFailure) {
                return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.extractCreateFailureExtractCreationDatasource, {
                    NAME: L10n_1.elideIfLong(datasourceName),
                });
            }
            else if (workbookCount === 1) {
                var titleMessage = isDatasourceFailure
                    ? messages_1.Messages.extractCreateFailureExtractCreationWithNameNoLink
                    : messages_1.Messages.extractCreateFailureExtractCreationWithName;
                return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(titleMessage, { NAME: L10n_1.elideIfLong(workbookName) });
            }
            else {
                return messages_1.Messages.failureExtractCreationWorkbooksWithCount({
                    LIST_COUNT: workbookCount,
                    LIST_COUNT_LOC: Localize_1.Formatters.formatCount(workbookCount),
                });
            }
        }
        else {
            if (workbookCount === 0) {
                return messages_1.Messages.outOfDateWorkbookNone();
            }
            else if (workbookCount === 1) {
                var titleMessage = isDatasourceFailure
                    ? messages_1.Messages.extractFailureOutOfDateWithNameNoLink
                    : messages_1.Messages.extractFailureOutOfDateWithName;
                return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(titleMessage, { NAME: L10n_1.elideIfLong(workbookName) });
            }
            else {
                return messages_1.Messages.outOfDateWorkbooksWithCount({
                    LIST_COUNT: workbookCount,
                    LIST_COUNT_LOC: Localize_1.Formatters.formatCount(workbookCount),
                });
            }
        }
    };
    ExtractContentProvider.prototype.getNotificationContent = function (notification) {
        var content = notification.content;
        var datasourceName = content.datasourceName;
        var lastFailureTime = notification.eventTime;
        var lastSuccessTime = content.lastSuccessTime ? new Date(content.lastSuccessTime) : null;
        var lookBackDays = content.lookBackDays;
        var statusCode = content.statusCodeId;
        var isSuspension = notification.type === UserNotificationType_1.UserNotificationType.RefreshExtractSuspension;
        var failureThreshold = content.failureThreshold;
        var failureCount = content.consecutiveFailureCount;
        var newLine = messages_1.Messages.newLine();
        var isDatasourceFailure = !!content.dataConnectionId;
        var message = '';
        if (!(isDatasourceFailure && notification.type === UserNotificationType_1.UserNotificationType.CreateExtractFailure)) {
            if (isDatasourceFailure && datasourceName) {
                message = MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.extractDataSourceWithLinkMessage, { DATASOURCE_NAME: datasourceName }) + newLine;
            }
            else {
                message =
                    MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.extractDataSourceMessage, {
                        DATASOURCE_NAME: datasourceName ? datasourceName : messages_1.Messages.embedded(),
                    }) + newLine;
            }
        }
        if (notification.type === UserNotificationType_1.UserNotificationType.CreateExtractFailure) {
            message +=
                messages_1.Messages.extractFailureTime({
                    FAILURE_TIME_TYPE: messages_1.Messages.extractCreationFailed(),
                    FAILURE_TIME: this.dateTimeOrNever(lastFailureTime, lookBackDays),
                }) + newLine;
        }
        else {
            message +=
                messages_1.Messages.extractFailureMessage({
                    FAILURE_TYPE: this.getFailureType(isSuspension, failureThreshold, statusCode),
                    FAILURE_MESSAGE: this.failureMessage(isSuspension, failureThreshold, failureCount, statusCode),
                }) + newLine;
            message +=
                messages_1.Messages.extractFailureTime({
                    FAILURE_TIME_TYPE: this.isRemoteRefreshWarning(statusCode)
                        ? this.warningTimestampPrompt(statusCode)
                        : messages_1.Messages.tableRefreshFailed(),
                    FAILURE_TIME: this.dateTimeOrNever(lastFailureTime, lookBackDays),
                }) + newLine;
            message += messages_1.Messages.extractLastRefreshMessage({ REFRESH_TIME: this.dateTimeOrNever(lastSuccessTime, lookBackDays) }) + newLine;
        }
        message += messages_1.Messages.extractResolutionMessage({ RESOLUTION_DETAIL: this.getResolutionDetails(statusCode) });
        return message;
    };
    ExtractContentProvider.prototype.getMaxShownContentLineCount = function () {
        return 8;
    };
    ExtractContentProvider.prototype.getFailureType = function (isSuspension, failureThreshold, statusCode) {
        var isRemoteRefresh = this.isRemoteRefresh(statusCode);
        var isRemoteRefreshingWarning = this.isRemoteRefreshWarning(statusCode);
        if (isSuspension && failureThreshold > 0 && !isRemoteRefresh) {
            return messages_1.Messages.tableSuspendedType();
        }
        else if (isRemoteRefreshingWarning) {
            return messages_1.Messages.tableWarningType();
        }
        else {
            return messages_1.Messages.tableFailureType();
        }
    };
    ExtractContentProvider.prototype.dateTimeOrNever = function (date, lookBackDaysLimit) {
        if (date) {
            return L10n_1.localizedDateTime(date);
        }
        else {
            if (lookBackDaysLimit > 0) {
                return messages_1.Messages.lastRunSuccess({
                    LOOK_BACK_DAYS: lookBackDaysLimit,
                    LOOK_BACK_DAYS_LOC: Localize_1.Formatters.formatCount(lookBackDaysLimit),
                });
            }
            else {
                return messages_1.Messages.never();
            }
        }
    };
    ExtractContentProvider.prototype.warningTimestampPrompt = function (statusCode) {
        if (statusCode === AlertErrorCodes_1.AlertErrorCode.AlertRemoteExtractRefreshNotFinishedOnTime ||
            statusCode === AlertErrorCodes_1.AlertErrorCode.AlertRemoteBridgeClientNotRunning) {
            return messages_1.Messages.tableAlertCreated();
        }
        else {
            return messages_1.Messages.tableRefreshFailed();
        }
    };
    ExtractContentProvider.prototype.isRemoteRefresh = function (statusCode) {
        var remoteRefreshStatusCodes = [
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteUnknownFailure,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteSignInFailed,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteExpiredPassword,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteNoPassword,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteConnectionFailure,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteInvalidFilePath,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteExtractRefreshNotFinishedOnTime,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteBridgeClientNotRunning,
        ];
        return _.contains(remoteRefreshStatusCodes, statusCode);
    };
    ExtractContentProvider.prototype.isRemoteRefreshWarning = function (statusCode) {
        var remoteRefreshWarningStatusCodes = [
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteExtractRefreshNotFinishedOnTime,
            AlertErrorCodes_1.AlertErrorCode.AlertRemoteBridgeClientNotRunning,
        ];
        return _.contains(remoteRefreshWarningStatusCodes, statusCode);
    };
    ExtractContentProvider.prototype.failureMessage = function (isSuspended, failureCountThreshold, failureCount, statusCode) {
        if (failureCountThreshold > 0) {
            var count = isSuspended ? failureCountThreshold : failureCount;
            return messages_1.Messages.failureNote({ COUNT: count, COUNT_LOC: Localize_1.Formatters.formatCount(count) });
        }
        else {
            return this.getStatusCodeMessage(statusCode);
        }
    };
    ExtractContentProvider.prototype.getStatusCodeMessage = function (statusCode) {
        switch (statusCode) {
            case AlertErrorCodes_1.AlertErrorCode.AlertSignInFailed:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteSignInFailed:
            case AlertErrorCodes_1.AlertErrorCode.AlertNoPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteNoPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertConnectionlessFailure:
                return messages_1.Messages.signInFailedUnknownReason();
            case AlertErrorCodes_1.AlertErrorCode.AlertExpiredPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteExpiredPassword:
                return messages_1.Messages.expiredPassword();
            case AlertErrorCodes_1.AlertErrorCode.AlertAccessTokenValidation:
                return messages_1.Messages.accessTokenValidation();
            case AlertErrorCodes_1.AlertErrorCode.AlertAuthConfiguration:
                return messages_1.Messages.authConfiguration();
            case AlertErrorCodes_1.AlertErrorCode.AlertConnectionFailure:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteConnectionFailure:
                return messages_1.Messages.connectionFailure();
            case AlertErrorCodes_1.AlertErrorCode.AlertInvalidFilePath:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteInvalidFilePath:
                return messages_1.Messages.invalidFilePath();
            case AlertErrorCodes_1.AlertErrorCode.AlertOverlappingSchedules:
                return messages_1.Messages.overlappingSchedules();
            case AlertErrorCodes_1.AlertErrorCode.AlertFullRefreshRequired:
                return messages_1.Messages.fullRefreshRequired();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteTableNotFound:
                return messages_1.Messages.tableNotFound();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteUnknownColumn:
                return messages_1.Messages.unknownColumn();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteQueryCompilation:
                return messages_1.Messages.queryCompilationError();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteFederatedError:
                return messages_1.Messages.federatedError();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteInvalidSemiStructDataSchema:
                return messages_1.Messages.invalidSemiStructDataSchema();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteUnableToConnectToFile:
                return messages_1.Messages.unableToConnectToFile();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteNoDriver:
                return messages_1.Messages.noDriver();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteIncompatibleDocumentVersion:
                return messages_1.Messages.incompatibleDocumentVersion();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteExtractRefreshNotFinishedOnTime:
                return messages_1.Messages.extractRefreshNotFinishedOnTime();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteBridgeClientNotRunning:
                return messages_1.Messages.bridgeClientNotRunning();
            default:
                return messages_1.Messages.unknownFailure();
        }
    };
    ExtractContentProvider.prototype.getResolutionDetails = function (statusCode) {
        switch (statusCode) {
            case AlertErrorCodes_1.AlertErrorCode.AlertSignInFailed:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteSignInFailed:
            case AlertErrorCodes_1.AlertErrorCode.AlertNoPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteNoPassword:
                return messages_1.Messages.signInFailedUnknownReasonResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertExpiredPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteExpiredPassword:
            case AlertErrorCodes_1.AlertErrorCode.AlertAccessTokenValidation:
            case AlertErrorCodes_1.AlertErrorCode.AlertAuthConfiguration:
            case AlertErrorCodes_1.AlertErrorCode.AlertConnectionFailure:
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteConnectionFailure:
                return messages_1.Messages.dataConnectionResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertInvalidFilePath:
                return messages_1.Messages.invalidFilePathResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteInvalidFilePath:
                return messages_1.Messages.invalidFilePathResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertOverlappingSchedules:
                return messages_1.Messages.overlappingSchedulesResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertFullRefreshRequired:
                return messages_1.Messages.fullRefreshRequiredResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertConnectionlessFailure:
                return messages_1.Messages.connectionlessFailureResolutionDetails();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteInvalidSemiStructDataSchema:
                return messages_1.Messages.invalidSemiStructDataSchemaResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteUnableToConnectToFile:
                return messages_1.Messages.unableToConnectToFileResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteUnknownColumn:
                return messages_1.Messages.unknownColumnResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteFederatedError:
                return messages_1.Messages.federatedErrorResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteQueryCompilation:
                return messages_1.Messages.queryCompilationErrorResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteTableNotFound:
                return messages_1.Messages.tableNotFoundResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteNoDriver:
                return messages_1.Messages.noDriverResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteIncompatibleDocumentVersion:
                return messages_1.Messages.incompatibleDocumentVersionResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteWDCAbortError:
                return messages_1.Messages.wdcAbortErrorResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteWDCInvalidData:
                return messages_1.Messages.wdcInvalidDataResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteExtractRefreshNotFinishedOnTime:
                return messages_1.Messages.extractRefreshNotFinishedOnTimeResolutionDetailsRemote();
            case AlertErrorCodes_1.AlertErrorCode.AlertRemoteBridgeClientNotRunning:
                return messages_1.Messages.bridgeClientNotRunningResolutionDetailsRemote();
            default:
                return messages_1.Messages.unknownFailureResolutionDetails();
        }
    };
    ExtractContentProvider.prototype.getErrorMessage = function (notification) {
        var _a;
        var urlError = notificationHelper_1.isNullOrUndefined((_a = notification.targetInfo) === null || _a === void 0 ? void 0 : _a.targetUrl);
        var errorMessage = '';
        if (urlError) {
            errorMessage =
                notification.content.workbookCount === 0
                    ? messages_1.Messages.extractDataSourceNotFoundErrorMessage()
                    : messages_1.Messages.extractWorkbookNotFoundErrorMessage();
        }
        return errorMessage;
    };
    return ExtractContentProvider;
}(NotificationDefaultProvider_1.NotificationDefaultProvider));
exports.ExtractContentProvider = ExtractContentProvider;
//# sourceMappingURL=ExtractContentProvider.js.map